module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"btn":"选择文件"}}')
  delete Component.options._Ctor
}
